import { Pipe } from '@angular/core';
@Pipe({
  name: 'if_null'
})
export class IfNullPipe {
  transform(value) {
    return value === null || value === '' || value === undefined ? 'N/A' : value;
  }
}
